<template>
    <el-dialog @close='closeDialog' :visible.sync="dialogVisible">
        <div class="preview_pop_box">
            <p class="tips_text">报告预览完啦，快去获取查看完整报告吧！</p>
            <p class="report_name_text">{{reportInfo.subject}}</p>
            <p class="price_text">
                <span v-if="reportInfo.feetype === 1">免费</span>
                <span v-if="reportInfo.feetype === 2">¥{{reportInfo.saleprice}}</span>
                <span v-if="reportInfo.feetype === 2">¥{{reportInfo.uprice}}</span>
            </p>
            <div class="btn_box">
                <el-button @click="freeGet" v-if="reportInfo.feetype === 1" type="danger"><img :src="require('@/common/images/report/free_icon.png')" alt=""> 免费获取</el-button>
                <el-button @click="buyNow" v-if="reportInfo.feetype === 2" type="danger"><img :src="require('@/common/images/report/buy_icon.png')" alt=""> 立即购买</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {updateJoinReport} from 'api/reportApi'
// import $ from 'jquery'
export default {
    name: 'PreviewTipsPop',
    data() {
        return {
            dialogVisible: false,
            reportInfo: {
                subject: '',
                uprice: '',
                saleprice: '',
                feetype: null
            }
        }
    },
    mounted() {},
    methods: {
        // 立即购买
        buyNow() {
            if(this.user.isLogin===true){
                // this.$router.push({name: 'OrderIndex', query: {'reportid': this.$route.query.reportid, kmctype: 2}})
                this.$router.push({name: 'OrderIndex', query: {'kmcinnerid': this.$route.query.reportid, kmctype: 2}})
            }else{
                this.setLoginPop(true)
            }
        },
        // 免费获取
        freeGet(){
            this.setLoading(true);
            let params = {
                reportid: this.$route.query.reportid,
            };
            updateJoinReport({
                data: Object.assign({}, params),
                success: data => {
                    console.log(data);
                    this.setLoading(false);
                    // this.$router.push({name: 'ReportDetails', query: {reportid: this.$route.query.reportid}})
                    this.$message.success('你已获取成功！');
                    this.closeDialog()
                    this.$emit('feetcallback')
                },
                error: data => {
                    this.$message.error(data.msg)
                }
            })
        },
        // 打开弹窗
        // openDialog(val) {
        openDialog(data) {
            // console.log(data)
            this.reportInfo = data
            this.dialogVisible = true
        },
        // 关闭弹框
        closeDialog() {
            this.dialogVisible = false
        },
        ...mapActions([
            'setLoading',
            'setLoginPop'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .preview_pop_box {
        font-family:PingFangSC-Regular,PingFang SC;
        display: flex;
        flex-direction: column;
        // justify-content: center;
        align-items: center;
        .tips_text {
            color:rgba(64,158,255,1);
            line-height:34px;
            font-size:20px;
        }
        .report_name_text {
            line-height:22px;
            font-size:16px;
            color: #333;
            margin: 20px 0;
        }
        .price_text {
            // &>span{}
            &>span:nth-of-type(1){
                color: #FF4747;
                line-height:26px;
                font-size:18px;
                margin-right: 15px;
            }
            &>span:nth-of-type(2){
                color: #666;
                line-height:20px;
                font-size:14px;
                text-decoration: line-through;
            }
        }
        .btn_box {
            margin-top: 18px;
            .el-button {
                width: 170px;
                &>span {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 16px;
                    line-height: 22px;
                    &>img {
                        width: 20px;
                        height: 20px;
                        margin-right: 8px;
                    }
                }
            }
        }
    }
</style>
